import { jsx as _jsx } from "react/jsx-runtime";
import CardActionArea from '@mui/material/CardActionArea';
const CardActionAreaNext = props => (_jsx(CardActionArea, { ...props }));
export { CardActionAreaNext };
